const Ariunaa = () => {
    return (
        <div className="Ariunaa_Font">
            <p>
                Hi, I’m Ariunaa, a first-generation American originally from Ulan-Ude, Siberian
                region in Russia, I take great pride in my Buryat-Mongolian heritage. My
                interest in software engineering started with graphic design and 3D modeling
                applications for jewelry, which eventually led me down the path of becoming a
                software engineer.

                <br/> <br/>

                The Pursuit program has been an incredible experience for me, providing a
                supportive space to learn and grow as a person and professional. I am grateful
                for the resources, mentorship, and opportunities I have found at Pursuit.

                <br/> <br/>

                Aside from Pursuit and learning to build software, during my free time I enjoy
                reading and being physically active. I practiced Muay Thai kickboxing for a few
                years and it helped me to build character and navigate the world better. I find
                that physical activity not only benefits my health, but also helps me clear my
                mind and feel energized throughout the day.

                <br/> <br/>

                I believe that meaningful work involves creating a sustainable future and
                restoring balance to our environment. Our world faces numerous challenges,
                including climate change and the threat of nuclear conflicts. I believe that
                it’s our responsibility to take action and do our part in creating a more
                sustainable and equitable future. 
                <br /> <br />
                Check out my <a href="https://www.linkedin.com/in/ariunaa-myagmar/" target="_blank"> LinkedIn </a> and <a href='https://github.com/ariunaamy' target="_blank"> GitHub </a> to see what I’ve been working on.
            </p>
        </div>
    )
}

export default Ariunaa